'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNumbers(str) {
  return str.replace(/[^0-9.]/g, '');
}

var Phone = function Phone(_ref) {
  var number = _ref.number,
      props = (0, _objectWithoutProperties3.default)(_ref, ['number']);
  return _react2.default.createElement(
    _text2.default,
    (0, _extends3.default)({ href: 'tel:' + getNumbers(number) }, props),
    Phone.format(number)
  );
};

Phone.format = function formatPhoneNumber(str) {
  var number = getNumbers(str);
  return '(' + number.substring(0, 3) + ') ' + number.substring(3, 6) + ' - ' + number.substring(6, 10);
};

Phone.displayName = 'hui:Phone';
Phone.huiName = 'Phone';

Phone.propTypes = {
  number: _propTypes2.default.string.isRequired
};

Phone.defaultProps = {
  a: true
};

exports.default = Phone;
//# sourceMappingURL=Phone.js.map


//////////////////
// WEBPACK FOOTER
// ../phone/lib/Phone.js
// module id = 738
// module chunks = 0